var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColombia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 21,
    viewBox: "0 0 34 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "COLOMBIA_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_86976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000028298178645110628270000012378632010915953045_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.8218 0.685547H0.258789V20.2615H33.8218V0.685547Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_86976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.8218 0.685547H0.258789V10.4735H33.8218V0.685547Z",
    fill: "#F3D02F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_86976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000028298178645110628270000012378632010915953045__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.8218 0.685547H0.258789V20.2615H33.8218V0.685547Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_86976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.8218 10.4746H0.258789V15.3686H33.8218V10.4746Z",
    fill: "#22368F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_86976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000028298178645110628270000012378632010915953045__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.8218 0.685547H0.258789V20.2615H33.8218V0.685547Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_86976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.8218 15.3672H0.258789V20.2612H33.8218V15.3672Z",
    fill: "#BC0030"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColombia);
export default __webpack_public_path__ + "static/media/COLOMBIA.30e702aaa16440c86ee72be1f50f4ba1.svg";
export { ForwardRef as ReactComponent };